import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const application = Application.start()
const context = require.context("controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

import {} from 'jquery-ujs';

import Autocomplete from 'devbridge-autocomplete';

import PerfectScrollbar from 'perfect-scrollbar';
window.PerfectScrollbar = PerfectScrollbar;

import toastr from 'toastr';
window.toastr = toastr;

import "./toastr";
import "./common/p_uuid_cookie";
import "./vendor/google";

import "./outside/forms";
import "./outside/design_2017/base";
import "./outside/design_2017/common";
import "./outside/design_2017/toggle";
import "./outside/design_2017/accountant-menu";
import "./outside/design_2017/sort-menu";
import "./outside/design_2017/sticky";
import "./outside/design_2017/menu-onepage";
import "./outside/design_2017/modal-window";
import "./outside/design_2017/header";
import "./outside/design_2017/main-menu";
import "./outside/design_2017/doubletaptogo.min";
import "./outside/design_2017/video-modal";
import "./outside/design_2017/searchbar";
import "./outside/design_2017/modal-animations";
import "./outside/design_2017/features-movies";
import "./outside/design_2017/search/simple";
import "./outside/design_2017/search/advanced";
import "./outside/design_2017/simple-video";
import "./outside/profiles_common";
